"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_STORED_ESTIMATOR_SAMPLES = exports.DEFAULT_MIN_SAMPLE_DURATION_MS = exports.DEFAULT_MIN_BYTES_FOR_SAMPLE = exports.DEFAULT_LATENCY_ESTIMATE = exports.DEFAULT_SAMPLE_RATE = exports.DEFAULT_MIN_BYTES = exports.DEFAULT_BANDWIDTH_ESTIMATE = void 0;
exports.DEFAULT_BANDWIDTH_ESTIMATE = 1e6; // The default used in Shaka when other info is not available (1Mb)
exports.DEFAULT_MIN_BYTES = 128e3; // The default used in Shaka for the minimum number of bytes before we consider a bandwidth estimate valid (128KB)
exports.DEFAULT_SAMPLE_RATE = 1000;
exports.DEFAULT_LATENCY_ESTIMATE = 30;
exports.DEFAULT_MIN_BYTES_FOR_SAMPLE = 6000;
exports.DEFAULT_MIN_SAMPLE_DURATION_MS = 5;
exports.DEFAULT_STORED_ESTIMATOR_SAMPLES = 20;
